angular.module('account.settings')
    .component('accountSettingsPasswordComponent', {
        templateUrl: 'app/account/settings/password-change.html',
        controller: function (Account) {
            this.$onInit = () => {
                this.account = {}
            }

            this.finishPasswordChange = () => {
                if (this.account.newPassword !== this.account.confirmPassword) {
                    this.doNotMatch = true
                    return
                }
                this.doNotMatch = null
                this.error = null

                return Account.passwordChange({password: this.account.password, newPassword: this.account.newPassword}).$promise
                    .then(() => this.success = true)
                    .catch(() => {
                        this.error = true
                        this.account = {}
                    })
            }
        }
    })
